const SET_MODE = (state, value) => { state.mode = value }
const SET_IS_SAVING = (state, value) => { state.isSaving = value }

export default {
  SET_MODE,
  SET_IS_SAVING
}
